import { EmulationCategory } from './types'

export const defaultIcons = {
  [EmulationCategory.Execution]: 'play',
  [EmulationCategory.FileManipulation]: 'file-blank',
  [EmulationCategory.Network]: 'globe',
  [EmulationCategory.DecisionPoint]: 'node',
  [EmulationCategory.OtherEventsAndActions]: 'pin',
}
export const defaultCategory = EmulationCategory.OtherEventsAndActions

export const actionsCategories: Record<EmulationCategory, Record<string, string | null>> = {
  [EmulationCategory.Execution]: {
    Shell: 'shell',
    ExecQuery: 'file-lookup',
    LoadCreatedDll: 'upload',
    OpenWordDocument: 'folder-open',
    OpenWorkbook: 'folder-open',
    OpenPresentation: 'folder-open',
    OpenPublisherDocument: 'folder-open',
    ExecuteScript: 'script',
    PowerShell: 'shell',
    Retry: 'refresh',
    ShellCode: 'shell',
    StartProcess: 'start',
    LoadShadowVBAProject: 'upload',
    LoadNetAssembly: 'upload',
    InitWMIObject: null,
    AppActivate: null,
    Eval: null,
    CallbackBinary: null,
    ProcHollow: null,
    EvaluatePCode: null,
    ExecuteSchedulerJob: null,
    AddNetType: null,
    InvokeMethodOfLoadedAssembly: null,
    DllInjection: null,
    ExecuteService: null,
  },
  [EmulationCategory.FileManipulation]: {
    WriteTextFile: 'file-text',
    WriteBinaryFile: 'file-blank',
    CopyFile: 'copy',
    CopyFolder: 'copy',
    MoveFolder: 'file-export',
    DeleteFile: 'remove',
    ShellCreatedFile: 'shell',
    PasteOLE: 'copy',
    CopyProgram: 'copy',
    MoveFile: 'file-export',
    MoveProgram: 'file-export',
    CopyEntry: 'copy',
    RemoveFolder: 'remove',
    SaveAs: 'save',
    CreateFolder: 'add',
    RenamePath: 'edit',
    WriteConfig: 'edit',
    ModifyNormalTemplate: 'edit',
    ModifyCodeModule: 'edit',
    AddWorkbook: 'add',
    AddDocument: 'add',
    CreateFile: 'add',
    CreateShortcut: 'add',
    CallCreatedDll: null,
  },
  [EmulationCategory.Network]: {
    HttpRequest: 'http',
    AccessBadUrl: 'link',
    OpenUrl: 'link',
    DnsLookup: 'search',
    IpLookup: 'search',
    CallAPI: 'settings',
    ConnectNetwork: null,
    SendNetworkData: null,
    ReceiveNetworkData: null,
  },
  [EmulationCategory.DecisionPoint]: {
    Sleep: 'eye-closed',
    ExitInfiniteLoop: 'process',
    UseEnvironmentVariableInCondition: null,
    SuggestEnvironCondition: null,
    CompareEnvironmentVariable: null,
  },
  [EmulationCategory.OtherEventsAndActions]: {
    EvalFormula: 'formula',
    LocateAPIProc: 'settings',
    Event: 'calendar',
    Schedule: 'calendar',
    BindKey: 'key-bind',
    ReadRegistry: 'eye',
    ReadConfig: 'eye',
    WriteRegistry: 'edit',
    DeleteRegistry: 'remove',
    SuspiciousText: 'text-suspicious',
    Email: 'email',
    ReadBigFile: 'eye',
    ConnectDB: 'database',
    CloseWindow: 'close',
    FindWindow: 'search',
    SendKeys: 'forward',
    AccessEnvironmentVariable: 'unlock',
    StoreEnvironmentVariable: 'save',
    SuspiciousAccess: 'warning-triangle',
    EmbedScript: 'script',
    EmbedPackage: 'package',
    EmbedHtml: 'screen',
    EmbedOfficeFile: 'file-blank',
    EmbedEquation: 'formula',
    EventTrigger: 'target',
    CreateObject: 'add',
    DecodeEncodedScript: 'script',
    AccessStdStream: 'unlock',
    AccessLocale: 'unlock',
    OfficeFileInformation: 'file-blank',
    LoadBitmap: 'upload',
    SetCOMImpersonationLevel: 'package',
    UnZipFile: 'package-up',
    CompressArchive: 'package',
    MsSearch: 'search',
    ScreenShot: 'image',
    RegisterXLL: null,
    VirtualProtect: null,
    CloseVirusProtection: null,
    TypeText: null,
    SendChar: null,
    WindowCommand: null,
    RegExp: null,
    InstallProduct: null,
    SetCellValue: null,
    DDE: null,
    SuggestFileExtension: null,
    ConfigureWindowsDefender: null,
    InconsistentMimeType: null,
    RegisterService: null,
    RewriteExit: null,
    MountNetDisk: null,
  },
}

export const categoriesColors = {
  [EmulationCategory.Execution]: 'blue',
  [EmulationCategory.FileManipulation]: 'raspberry',
  [EmulationCategory.Network]: 'teal-blue',
  [EmulationCategory.DecisionPoint]: 'purple',
  [EmulationCategory.OtherEventsAndActions]: 'grey',
}
